export default __webpack_public_path__ + "static/animation_drag_mouse-5dae0c7ff30fdaa759f80ba1754e3ba1.mp4";